import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Services } from "@/components/site/Services";
import { Portfolio } from "@/components/site/Portfolio";
import { Artists } from "@/components/site/Artists";
import { About } from "@/components/site/About";
import { QuoteSection } from "@/components/site/QuoteSection";
import { Footer } from "@/components/site/Footer";
import AdminQuotes from "@/pages/AdminQuotes";
import AdminTracks from "@/pages/AdminTracks";
import AdminContracts from "@/pages/AdminContracts";
import SignContract from "@/pages/SignContract";

const Landing = () => {
  return (
    <div className="App font-body bg-background text-foreground" data-testid="landing-root">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <About />
        <Portfolio />
        <Artists />
        <QuoteSection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin" element={<AdminQuotes />} />
        <Route path="/admin/quotes" element={<AdminQuotes />} />
        <Route path="/admin/tracks" element={<AdminTracks />} />
        <Route path="/admin/contracts" element={<AdminContracts />} />
        <Route path="/sign/:token" element={<SignContract />} />
      </Routes>
      <Toaster
        theme="dark"
        position="top-center"
        toastOptions={{
          style: {
            background: "#111",
            color: "#fff",
            border: "1px solid rgba(255,255,255,0.1)",
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;
